//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import appStats from "@/components/Diagrams/sidebar/appStats.vue";
import { eventBus } from "../../../assets/js/appFunc";

export default {
    /* eslint-disable vue/no-unused-components */
    components: {
        appStats,
        setLabel: () => import(/* webpackChunkName: "setLabel" */ "@/components/Diagrams/config/set-label.vue"),
        setCode: () => import(/* webpackChunkName: "setCode" */ "@/components/Diagrams/config/set-code.vue"),
        setDeadline: () => import(/* webpackChunkName: "setDeadline" */ "@/components/Diagrams/config/set-deadline.vue"),
        setExpiration: () => import(/* webpackChunkName: "setExpiration" */ "@/components/Diagrams/config/set-expiration.vue"),
        setTaskPriority: () => import(/* webpackChunkName: "setTaskPriority" */ "@/components/Diagrams/config/set-task-priority.vue"),
        setDescription: () => import(/* webpackChunkName: "setDescription" */ "@/components/Diagrams/config/set-description.vue"),
        setGui: () => import(/* webpackChunkName: "setGui" */ "@/components/Diagrams/config/set-gui.vue"),
        setInstanceName: () => import(/* webpackChunkName: "setInstanceName" */ "@/components/Diagrams/config/set-instance-name.vue"),
        setTaskSubject: () => import(/* webpackChunkName: "setTaskSubject" */ "@/components/Diagrams/config/set-task-subject.vue"),
        setProcess: () => import(/* webpackChunkName: "setProcess" */ "@/components/Diagrams/config/set-process.vue"),
        setTarget: () => import(/* webpackChunkName: "setTarget" */ "@/components/Diagrams/config/set-target.vue"),
        setSMS: () => import(/* webpackChunkName: "setSMS" */ "@/components/Diagrams/config/set-external-task-sms.vue"),
        setEmail: () => import(/* webpackChunkName: "setEmail" */ "@/components/Diagrams/config/set-external-task-email.vue"),
        setMessagingOptions: () => import(/* webpackChunkName: "setMessagingOptions" */ "@/components/Diagrams/config/set-messaging-options.vue"),
        setUsers: () => import(/* webpackChunkName: "setUsers" */ "@/components/Diagrams/config/set-users.vue"),
        setApi: () => import(/* webpackChunkName: "setApi" */ "@/components/Diagrams/config/set-api.vue"),
        setExposeApi: () => import(/* webpackChunkName: "setExposeApi" */ "@/components/Diagrams/config/set-expose-api.vue"),
        setDynamicTask: () => import(/* webpackChunkName: "setDynamicTask" */ "@/components/Diagrams/config/set-dynamic-external-task.vue"),
        setDocumentsToGenerate: () => import(/* webpackChunkName: "setDocumentsToGenerate" */ "@/components/Diagrams/config/set-documents-to-generate.vue"),
        setExclusiveGateway: () => import(/* webpackChunkName: "setExclusiveGateway" */ "@/components/Diagrams/config/set-exclusive-gateway.vue"),
        setRules: () => import(/* webpackChunkName: "setRules" */ "@/components/Diagrams/config/set-rules.vue"),
        setLevels: () => import(/* webpackChunkName: "setLevels" */ "@/components/Diagrams/config/set-levels.vue"),
        setStatus: () => import(/* webpackChunkName: "setStatus" */ "@/components/Diagrams/config/set-status.vue"),
        setExternalStart: () => import(/* webpackChunkName: "setExternalStart" */ "@/components/Diagrams/config/set-external-start.vue"),
        setExternalPlugin: () => import(/* webpackChunkName: "setExternalPlugin" */ "@/components/Diagrams/config/set-external-plugin.vue"),
        setBlockchainFunction: () => import(/* webpackChunkName: "setBlockchainFunction" */ "@/components/Diagrams/config/set-blockchain-function.vue"),
        setBlockchainEvent: () => import(/* webpackChunkName: "setBlockchainEvent" */ "@/components/Diagrams/config/set-blockchain-event.vue"),
        setRecurrence: () => import(/* webpackChunkName: "setRecurrence" */ "@/components/Diagrams/config/set-recurrence.vue"),
        setConfigureAdvancedLogic: () => import(
            /* webpackChunkName: "setConfigureAdvancedLogic" */
            "@/components/Diagrams/config/set-configure-advanced-logic.vue"
        )
    },
    props: {
        openCollapsible: {
            type: Boolean,
            default: false
        },
        openDescriptionCard: {
            type: Boolean,
            default: false
        },
        allTasksReady: {
            type: Boolean
        },
        isOpenAndCompleted: {
            type: Boolean
        },
        readonly: {
            type: Boolean
        },
        plvMode: {
            type: Boolean,

            default: false
        },
        plvStatisticsSidebar: Boolean,
        turnAroundValue: {
            type: String,
            default: ""
        },
        diagramWarnings: {
            type: Array,
            default: () => []
        },
        diagramErrors: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            reduceMaxHeight: "",
            addHeight: "",
            taskNrObj: {
                activityNr: {},
                endPointsNr: {}
            },
            nrOfFiltredTasks: "",
            filtredEndpointsUuids: [],
            filtredActivityUuids: [],
            selectedTab: "details",
            labelReadonly: null,
            opened: false,
            oldLabel: "",
            plvSidebarData: {
                plvActivities: {
                    label: this.$t("liveView.taskDetails.activitiesCollapsibleLabel"),
                    data: []
                },
                plvEndPoints: {
                    label: this.$t("liveView.taskDetails.endpointsCollapsibleLabel"),
                    data: []
                }
            },
            pluginsFilterArray: [
                "GENERAL_START_PLUGIN",
                "API_PLUGIN",
                "GENERATE_DOCUMENT_PLUGIN",
                "BLOCKCHAIN_PLUGIN",
                "EXCLUSIVE_GATEWAY_PLUGIN",
                "PARALLEL_GATEWAY_PLUGIN",
                "JOIN_GATEWAY_PLUGIN"
            ],
            pluginsFilteredForStatistics: [
                "GENERAL_START_PLUGIN",
                "API_PLUGIN",
                "GENERATE_DOCUMENT_PLUGIN",
                "BLOCKCHAIN_PLUGIN",
                "EXCLUSIVE_GATEWAY_PLUGIN",
                "PARALLEL_GATEWAY_PLUGIN",
                "JOIN_GATEWAY_PLUGIN",
                "DATA_EXPORT_PLUGIN",
                "EXPOSE_API_PLUGIN",
                "GENERAL_END_PLUGIN"
            ],
            collapsibleOpenId: ""
        };
    },
    computed: {
        ...mapGetters("reports", ["getFiltredTasks", "filterObject", "getSelectedProcessStatistics"]),
        ...mapGetters("diagrams", ["diagramData", "diagramPlugins", "selectedPluginUuid", "externalTask", "selectedPluginConfigData", "diagramConfigData"]),
        checkSystemStages() {
            let finalElementsToReturn = [];
            if (this.plvStatisticsSidebar) {
                const filteredContentBasedOnPlugins = this.diagramData.content.filter(
                    el => this.pluginsFilteredForStatistics.indexOf(el.label.pluginID) === -1
                );
                for (let i = 0; i < filteredContentBasedOnPlugins.length; i++) {
                    if (filteredContentBasedOnPlugins[i].label.pluginID === "PROCESS_PLUGIN") {
                        for (let j = 0; j < this.diagramConfigData.content.length; j++) {
                            if (
                                filteredContentBasedOnPlugins[i].label.pluginUUID === this.diagramConfigData.content[j].uuid
                                && !this.diagramConfigData.content[j].process.isAsync
                            ) {
                                finalElementsToReturn.push(filteredContentBasedOnPlugins[i]);
                            }
                        }
                    } else {
                        finalElementsToReturn.push(filteredContentBasedOnPlugins[i]);
                    }
                }
            } else {
                finalElementsToReturn = this.diagramData.content;
            }
            return finalElementsToReturn;
        },
        parsedDiagramPlugins() {
            const data = {};

            this.diagramPlugins.forEach(el => {
                data[el.id] = {
                    ...el,
                    components: {
                        details: [],
                        targets: [],
                        users: [],
                        rules: [],
                        levels: []
                    }
                };

                el.components.forEach(comp => {
                    data[el.id].components[comp.category].push(comp);
                });
            });

            return data;
        }
    },
    watch: {
        openDescriptionCard: {
            handler(newValue) {
                if (!newValue) {
                    this.reduceMaxHeight = "";
                }
            },
            immediate: true
        },
        getFiltredTasks: {
            handler(newValue) {
                const vm = this;
                if (newValue.length) {
                    vm.plvSidebarData.plvActivities.data = [];
                    vm.plvSidebarData.plvEndPoints.data = [];
                    vm.filtredActivityUuids = [];
                    vm.filtredEndpointsUuids = [];
                    const path = vm.filterObject.taskFilterModel;
                    const pathFilteres = (path.groupIds && path.groupIds.length)
                        || (path.priorities && path.priorities.length)
                        || (path.taskStatus && path.taskStatus.length)
                        || (path.userIds && path.userIds.length)
                        || vm.filterObject.searchTerm
                        || vm.filterObject.activeTasks !== undefined || this.isOpenAndCompleted;
                    newValue.forEach(task => {
                        if (task.total !== 0 && task.activityType !== "GENERAL_END_PLUGIN") {
                            vm.filtredActivityUuids.push(task.activityId);
                            if (pathFilteres) {
                                vm.taskNrObj.activityNr[task.activityId] = task.total;
                            } else {
                                vm.taskNrObj.activityNr = {};
                            }
                        } else if (task.total !== 0 && task.activityType === "GENERAL_END_PLUGIN") {
                            vm.filtredEndpointsUuids.push(task.activityId);
                            if (pathFilteres) {
                                vm.taskNrObj.endPointsNr[task.activityId] = task.total;
                            } else {
                                vm.taskNrObj.endPointsNr = {};
                            }
                        }
                    });
                    vm.diagramData.content.forEach(elem => {
                        if (vm.filtredActivityUuids.indexOf(elem.uuid) !== -1) {
                            vm.plvSidebarData.plvActivities.data.push(elem);
                        } else if (vm.filtredEndpointsUuids.indexOf(elem.uuid) !== -1) {
                            vm.plvSidebarData.plvEndPoints.data.push(elem);
                        }
                    });
                } else {
                    vm.plvSidebarData.plvActivities.data = [];
                    vm.plvSidebarData.plvEndPoints.data = [];
                    vm.filtredActivityUuids = [];
                    vm.filtredEndpointsUuids = [];
                }
            }
        },
        diagramData: {
            handler(newValue) {
                if (this.plvMode && newValue && !this.plvSidebarData.plvEndPoints.data.length) {
                    newValue.content.forEach(elem => {
                        if (this.pluginsFilterArray.indexOf(elem.id) === -1) {
                            if (elem.id === "GENERAL_END_PLUGIN") {
                                this.plvSidebarData.plvEndPoints.data.push(elem);
                            } else {
                                this.plvSidebarData.plvActivities.data.push(elem);
                            }
                        }
                    });
                }
            },
            immediate: true,
            deep: true
        }
    },
    created() {
        this.$on("changeSelectedTab", tabName => {
            this.selectedTab = tabName;
        });
        eventBus.$on("resetMaxHeight", errorPanelRef => {
            if (errorPanelRef) {
                const { clientHeight } = errorPanelRef.$el;
                this.reduceMaxHeight = `max-height: calc(100vh - ${clientHeight + 115}px);`;
            }
        });
    },
    deactivated() {
        this.plvStatisticsSidebar = false; //eslint-disable-line
        this.taskNrObj = {
            activityNr: {},
            endPointsNr: {}
        };
    },
    methods: {
        setActivePlugin(obj) {
            if (obj.uuid !== this.selectedPluginUuid) {
                const dataToSend = {
                    uuid: obj.uuid,
                    id: obj.id,
                    plvType: this.plvMode
                };
                this.$emit("pluginSelected", dataToSend);
            } else if (this.plvMode) {
                this.$emit("openDetails");
            }
        },
        setCustomClass(component, plugin) {
            let newClass = "";
            if ((component === "setGui" && (plugin === "TASK_PLUGIN" || plugin === "EXTERNAL_PLUGIN")) || component === "setTaskSubject") {
                newClass = "q-mb-sm";
            }
            if (component === "setInstanceName" && plugin === "EXTERNAL_PLUGIN") {
                newClass = "q-mb-md";
            }
            return newClass;
        },
        changeAllData(value) {
            this.$emit("turnAroundValueChanged", value);
        },
        save(value, component) {
            if (this.selectedPluginUuid) {
                if (component.propName === "expiration") {
                    this.setComponentNewData(value.deadline, "deadline", component.propType);
                    this.setComponentNewData(value.expiration, component.propName, component.propType);
                    this.setComponentNewData(value.notifications, "notifications", component.propType);
                } else {
                    this.setComponentNewData(value, component.propName, component.propType);
                }
            }
        },
        setComponentNewData(value, componentName, propType) {
            this.$store.commit("diagrams/setConfigData", {
                uuid: this.selectedPluginUuid,
                value,
                property: componentName,
                type: propType || "content"
            });
        },
        scrollCollapsible(i) {
            const collapsElem = document.getElementById(`idCollapse-${i}`);
            if (collapsElem) {
                if (this.openCollapsible) {
                    const collapsContainer = document.getElementById("pluginsList");
                    collapsContainer.scrollTop = Math.floor(collapsElem.offsetTop) - 50;
                } else {
                    collapsElem.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
                }
            } else {
                this.$nextTick(() => {
                    const newCollapsElem = document.getElementById(`idCollapse-${i}`);
                    this.addHeight = i;
                    const collapsContainer = document.getElementById("pluginsList");
                    const scrollDistance = newCollapsElem.offsetTop - collapsContainer.offsetTop;
                    collapsContainer.scrollTop = Math.floor(scrollDistance) - 50;
                });
            }
            this.$emit("removeIsOpenedCollapsible");
        },
        changeTab(i) {
            if (!this.plvStatisticsSidebar && this.labelReadonly !== i) {
                this.selectedTab = "details";
            }
        },
        collapsibleId(id, i) {
            if (this.openCollapsible) {
                this.addHeight = i;
            }
            this.collapsibleOpenId = id;
        },
        editLabel(i, oldLabel) {
            this.oldLabel = oldLabel;
            this.labelReadonly = i;
            this.opened = i;
            setTimeout(() => {
                this.$refs[`label-${i}`][0].focus();
            }, 100);
        },
        checkState(index) {
            if (this.addHeight === index) {
                this.addHeight = "";
            }
            this.labelReadonly = this.labelReadonly !== index ? this.labelReadonly : null;
            this.opened = this.opened !== index ? this.opened : null;
        },
        updateLabel(v, uuid, reset) {
            if (reset) {
                this.$emit("updateLabel", { property: "label", value: this.oldLabel, uuid });
            } else {
                this.$emit("updateLabel", { property: "label", value: v, uuid });
            }
        },
        open(i) {
            this.$refs[`refcollapse-${i}`][0].show();
        }
    }
};
